const context = require.context('./', false, /\.json$/);

const animations = context.keys().reduce((acc, key) => {
  const name = key.replace('./', '').replace('.json', '');
  acc[name] = context(key);
  return acc;
}, {});

export default animations;
